import { prompt, type PromptDefinition } from './models';

export const ENERGY_MANAGER_PROMPTS = [
    prompt(
        'Improve performance',
        'What do the energy reports say about this building?',
        'Compare energy reports across my buildings.'
    ),
    prompt(
        'Improve performance',
        'What energy-saving measures are recommended for this building?',
        'Which buildings have documented energy-saving opportunities to prioritise?'
    ),
    prompt(
        'Improve performance',
        'What metering and consumption records are available for this building?',
        'Which buildings have gaps in energy metering or consumption records?'
    ),
    prompt(
        'Improve performance',
        'Find energy audit recommendations for this building about…',
        'Find energy audit recommendations across my buildings about…',
        'prefill'
    ),
    prompt(
        'Improve performance',
        "What unusual consumption patterns are identified in this building's reports?",
        'Which buildings have unusual energy consumption flagged in their reports?'
    ),
    prompt(
        'Improve performance',
        "What operating schedules or setpoints affect this building's energy use?",
        'Compare documented operating schedules and energy-related setpoints across my buildings.'
    ),
    prompt(
        'Improve performance',
        "What evidence shows whether this building's energy upgrades achieved their goals?",
        'Which buildings lack evidence of results from completed energy upgrades?'
    ),
    prompt(
        'Improve performance',
        'Find utility consumption records for this building covering…',
        'Find utility consumption records across my buildings covering…',
        'prefill'
    ),
    prompt(
        'Improve performance',
        'What energy ratings and assessment dates are recorded for this building?',
        'Which buildings have outdated or missing energy assessments?'
    ),
    prompt(
        'Improve performance',
        "Which assumptions support this building's projected energy savings?",
        'Compare documented energy-savings assumptions across my buildings.'
    ),
    prompt(
        'Improve performance',
        "What follow-up measurements are recommended in this building's energy reports?",
        'Which buildings need follow-up measurements to verify energy performance?'
    ),
    prompt(
        'Improve performance',
        'Compare energy performance for this building between…',
        'Compare energy performance across my buildings for the period…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
